/* eslint-disable import/no-cycle */
// Utils
import { decommitValue } from './decommitValue';
import { COMMITTED_VALUES } from '../constants';
/**
 * Strips [COMMITTED_VALUES] from the object and nested objects
 *
 * @template T extends object
 * @param {Committable<T>} values
 *
 * @return {UnCommittable<T>}
 */
export var decommitObject = function (values) {
    var result = {};
    Object.keys(values).forEach(function (key) {
        if (key === COMMITTED_VALUES) {
            return;
        }
        result[key] = decommitValue(values[key]);
    });
    return result;
};
//# sourceMappingURL=decommitObject.js.map